import { round } from "utils";
import Session from "../utils/Session";
import Client from "./_client";

const apiUrl = process.env.REACT_APP_API_URL;

export const analyseAnswer = ({
  attemptId,
  questionId,
  timeTaken,
  // transcript,
  audioBlob,
  serialNumber,
  template,
  domain,
  isDaf=false
}, onEvent) => {
  const formData = new FormData();
  const httpRequest = new XMLHttpRequest();

  formData.append("question", questionId);
  formData.append("attempt", attemptId);
  formData.append("timeTaken", timeTaken);
  formData.append("serialNumber", serialNumber);
  formData.append("template", template);
  formData.append("domain", domain);
  formData.append("isDaf", isDaf);

  // formData.append("transcript", transcript);
  formData.append("audio", audioBlob);

  httpRequest.upload.addEventListener('progress', (e) => {
    const progress = round((e.loaded / e.total) * 100);
    onEvent('progress', progress);
  });

  httpRequest.onload = (e) => {
    const response = JSON.parse(e?.target?.response || null);

    if (e?.target?.status !== 200) {
      onEvent('error', response?.data);
    } else if (response?.data?.isError) {
      onEvent('analysed', response?.data);
    } else {
      onEvent('analysed', response?.data);
    }
  };
  httpRequest.onabort = (e) => {
    onEvent('error', e);
  };
  httpRequest.onerror = (e) => {
    onEvent('error', e);
  };

  httpRequest.open('POST', `${apiUrl}/analyse/interview`, true);
  httpRequest.setRequestHeader('userId', Session.userId);
  httpRequest.setRequestHeader('languify-application', 'interview');
  httpRequest.setRequestHeader('languify-access-token', Session.accessToken);
  httpRequest.setRequestHeader(
    "languify-session-id", localStorage?.getItem("languifySessionId")
  );
  httpRequest.send(formData);
};

export const skipQuestion = async ({
  questionId,
  attemptId,
  timeTaken,
  transcript,
  serialNumber,
}) => {
  const result = await new Client({
    path: `/analyse/interview/skip`,
    payload: {
      question: questionId,
      attempt: attemptId,
      timeTaken,
      serialNumber,
      transcript,
    }
  }).post();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to skip the question. Please refresh again."
    );
  }

  return result?.data;
}

export const analyseCodingExplanation = ({
  audioBlob,
  questionType,
  codeChallengeAttemptId,
  explainedAt,
  skip=false,
  duration= 0,
  autosubmitted=false
}, onEvent) => {
  const formData = new FormData();
  const httpRequest = new XMLHttpRequest();

  formData.append("questionType", questionType);
  formData.append("codeChallengeAttemptId", codeChallengeAttemptId);
  formData.append("explainedAt", explainedAt);
  formData.append("skip", skip);
  formData.append("duration", duration);
  formData.append("autosubmitted", autosubmitted);

  // formData.append("transcript", transcript);
  formData.append("audio", audioBlob);

  httpRequest.upload.addEventListener('progress', (e) => {
    const progress = round((e.loaded / e.total) * 100);
    onEvent('progress', progress);
  });

  httpRequest.onload = (e) => {
    const response = JSON.parse(e?.target?.response || null);

    if (e?.target?.status !== 200) {
      onEvent('error', response?.data);
    } else if (response?.data?.isError) {
      onEvent('analysed', response?.data);
    } else {
      onEvent('analysed', response?.data);
    }
  };
  httpRequest.onabort = (e) => {
    onEvent('error', e);
  };
  httpRequest.onerror = (e) => {
    onEvent('error', e);
  };

  httpRequest.open('POST', `${apiUrl}/analyse/code-explanation`, true);
  httpRequest.setRequestHeader('userId', Session.userId);
  httpRequest.setRequestHeader('languify-application', 'interview');
  httpRequest.setRequestHeader('languify-access-token', Session.accessToken);
  httpRequest.setRequestHeader(
    "languify-session-id", localStorage?.getItem("languifySessionId")
  );
  httpRequest.send(formData);
};

export const analyseCaseMasterProblem = ({
  audioBlob,
  duration = 0,
  casemasterAttemptId,
}, onEvent) => {
  const formData = new FormData();
  const httpRequest = new XMLHttpRequest();

  formData.append("audio", audioBlob);
  formData.append("duration", duration);
  formData.append("casemasterAttemptId", casemasterAttemptId);

  httpRequest.upload.addEventListener('progress', (e) => {
    const progress = round((e.loaded / e.total) * 100);
    onEvent('progress', progress);
  });

  httpRequest.onload = (e) => {
    const response = JSON.parse(e?.target?.response || null);

    if (e?.target?.status !== 200) {
      onEvent('error', response?.data);
    } else if (response?.data?.isError) {
      onEvent('analysed', response?.data);
    } else {
      onEvent('analysed', response?.data);
    }
  };
  httpRequest.onabort = (e) => {
    onEvent('error', e);
  };
  httpRequest.onerror = (e) => {
    onEvent('error', e);
  };

  httpRequest.open('POST', `${apiUrl}/analyse/casemaster-problem`, true);
  httpRequest.setRequestHeader('userId', Session.userId);
  httpRequest.setRequestHeader('languify-application', 'interview');
  httpRequest.setRequestHeader('languify-access-token', Session.accessToken);
  httpRequest.setRequestHeader(
    "languify-session-id", localStorage?.getItem("languifySessionId")
  );
  httpRequest.send(formData);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { analyseAnswer, skipQuestion, analyseCodingExplanation, analyseCaseMasterProblem };
